export default __webpack_public_path__ + "static/media/CTA_Icon.3b1c69d8.svg";